import React, { useEffect, useState } from "react";
import "./CartVertistyle.css";
import logo from "../../../assets/images/logocarterinha.png";
import userDefault from "../../../assets/images/user.png";
import ass from "../../../assets/images/ass.png";
import api from "../../../Services/api";
import Url_Image from "../../../assets/URL'S/Url_Image";

export default function CarteirinhaVertiPdf({ Dados, home, setLoadingFotos }) {
  const locale = "pt-BR";
  const [user, setUser] = useState("");
  const [alunoData, setAlunoData] = useState(Dados || {});

  useEffect(() => {
    if (home) {
      getDataUser();
      return; // apenas sai do efeito, sem retornar valor
    }
    if (Dados.fileImgManual) {
      setUser(Dados.fileImgManual);
      return;
    }
    if (Dados.email && Dados.id_curso) {
      setLoadingFotos(true);
      fetchImage(Dados.rm);
    }
  }, [Dados, home]);

  async function fetchImage(rm) {
    try {
      const imgBase64 = await Url_Image(rm);
      setUser(imgBase64);
    } catch (error) {
      console.log("erro ->", error);
    } finally {
      setLoadingFotos(false);
    }
  }

  async function getDataUser() {
    const token = localStorage.getItem("token");

    try {
      const response = await api.get("/aluno/perfil", { headers: { Authorization: `Bearer ${token}` } });
      if (response.data) {
        setAlunoData(response.data);
        const imgBase64 = await Url_Image(response.data.rm);
        setUser(imgBase64);
      }
    } catch (error) {
      console.error("Erro ao buscar os dados do aluno:", error);
      setUser(userDefault);
    }
  }

  return (
    <div className="globalMobilepdf">
      <div className="circleMobilepdf" style={{ backgroundColor: alunoData.cor_convenio || "#ccc" }}></div>
      <div className="quadrosMobilepdf">
        <img src={user || userDefault} alt="perfil" className="perfilfotoMobile" />
      </div>
      <div className="infocardMobilepdf">
        <h1 className="namesMobilepdf">{alunoData.nome_aluno ?? Dados?.nome ?? "Nome Indisponível"}</h1>
        <div className="cardsssMobilepdf">
          <div className="columnsMobilepdf">
            <p>RM</p>
            <p style={{ fontWeight: 700 }}>{alunoData.rm ?? "N/A"}</p>
          </div>
          <div className="columnsMobileCpdf">
            <p>Curso</p>
            <p className="nomeCursoMobilepdf">{alunoData.nome_curso ?? "N/A"}</p>
          </div>
          <div className="columnsMobilepdf">
            <p>Validade</p>
            <p style={{ color: "red", fontWeight: "700" }}>
              {alunoData.dt_termino ? new Date(alunoData.dt_termino).toLocaleDateString(locale) : "N/A"}
            </p>
          </div>
        </div>
      </div>
      <div className="imgamesMobilepdf">
        <img src={logo} alt="logo" className="logofiec" />
        <img src={ass} alt="assinatura" className="assinatura" />
      </div>
      <div className="logonameMobilepdf">
        <p style={{ fontWeight: "600" }}>Prefeitura Municipal De Indaiatuba</p>
      </div>
      <p className="paragrafosMobilepdf">
        Este cartão é de uso estritamente pessoal e intransferível. O acesso à escola somente será permitido mediante
        apresentação desse cartão ou autorização da secretaria.
      </p>
      <div className="convenioMobilepdf" style={{ backgroundColor: alunoData.cor_convenio || "#ccc" }}>
        <p className="expoMobilepdf">{alunoData.convenio ?? "N/A"}</p>
      </div>
    </div>
  );
}
